export type Region = "ie" | "uk";

export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000";

export const PORTAL_URL = "https://portal.optilase.com/";
const PORTAL_URL_UK = "https://portaluk.optilase.com/";

export function portalUrl(region: Region): string {
  return region === "uk" ? PORTAL_URL_UK : PORTAL_URL;
}

export const REGION_LANG: Record<Region, string> = {
  ie: "en-IE",
  uk: "en-GB",
};

export function regionFromPathname(pathname: string): Region {
  return pathname === "/uk" || pathname.startsWith("/uk/") ? "uk" : "ie";
}

export function isLpPath(pathname: string | null | undefined): boolean {
  const parts = (pathname || "/").split("/").filter(Boolean);
  const rest = parts[0] === "uk" || parts[0] === "ie" ? parts.slice(1) : parts;
  return rest[0] === "lp";
}

export function splitPath(parts: string[]): {
  region: Region;
  basePath: string;
} {
  const isUk = parts[0] === "uk";
  const rest = (isUk ? parts.slice(1) : parts).join("/");
  return { region: isUk ? "uk" : "ie", basePath: rest };
}

const NON_PAGE_PATH = /^\/(share|assets|icons|data|api|_next)(\/|$)|\.[a-z0-9]+$/i;

export function isNonPagePath(path: string): boolean {
  return NON_PAGE_PATH.test(path.split(/[?#]/)[0]);
}

export function withTrailingSlash(path: string): string {
  if (!path) return "/";
  if (/^(https?:|mailto:|tel:|#)/i.test(path)) return path;
  if (isNonPagePath(path)) return path;
  if (path === "/" || path.startsWith("/api/") || path === "/api") return path;

  const hashIdx = path.indexOf("#");
  const queryIdx = path.indexOf("?");
  const splitIdx =
    hashIdx === -1 ? queryIdx : queryIdx === -1 ? hashIdx : Math.min(hashIdx, queryIdx);
  const pathnameEnd = splitIdx === -1 ? path.length : splitIdx;
  const pathname = path.slice(0, pathnameEnd);
  const suffix = path.slice(pathnameEnd);
  if (pathname.endsWith("/")) return path;
  return `${pathname}/${suffix}`;
}

export function regionPath(path: string, region: Region): string {
  if (region !== "uk") return withTrailingSlash(path);
  if (path === "/uk" || path.startsWith("/uk/")) return withTrailingSlash(path);
  if (path === "/") return "/uk/";
  return withTrailingSlash(`/uk${path}`);
}

export function buildRegionUrls(basePath: string) {
  const iePath = basePath ? `/${basePath}/` : "/";
  const ukPath = basePath ? `/uk/${basePath}/` : "/uk/";
  return {
    ie: `${SITE_URL}${iePath}`,
    uk: `${SITE_URL}${ukPath}`,
    iePath,
    ukPath,
  };
}
